import styled, { css } from 'styled-components';

type LoaderProps = { isLoading: boolean };

export const LoaderBlurContainer = styled.div`
  position: relative;
`;

export const LoaderBlur = styled.div<LoaderProps>`
  ${({ isLoading }) =>
    isLoading &&
    css`
      height: 100%;
      content: '';
      width: 100%;
      z-index: 1;
      top: 0;
      left: 0;
    `}

  & > div.blur {
    filter: ${({ isLoading }) => (isLoading ? 'blur(5px)' : 'none')};
  }
`;

export const LoaderContainer = styled.div`
  width: 100%;

  .sk-cube-grid {
    width: 50px;
    height: 50px;
    margin: 100px auto;
  }

  .sk-cube-grid .sk-cube {
    width: 33%;
    height: 33%;
    background-color: ${({ theme }) => theme.UI_COLORS.secondary};
    box-shadow: 0 0 10px 5px rgba(0, 0, 0, 0.25);
    float: left;
    animation: sk-cubeGridScaleDelay 1.3s infinite ease-in-out;
  }
  .sk-cube-grid .sk-cube1 {
    animation-delay: 0.2s;
  }
  .sk-cube-grid .sk-cube2 {
    animation-delay: 0.3s;
  }
  .sk-cube-grid .sk-cube3 {
    animation-delay: 0.4s;
  }
  .sk-cube-grid .sk-cube4 {
    animation-delay: 0.1s;
  }
  .sk-cube-grid .sk-cube5 {
    animation-delay: 0.2s;
  }
  .sk-cube-grid .sk-cube6 {
    animation-delay: 0.3s;
  }
  .sk-cube-grid .sk-cube7 {
    animation-delay: 0s;
  }
  .sk-cube-grid .sk-cube8 {
    animation-delay: 0.1s;
  }
  .sk-cube-grid .sk-cube9 {
    animation-delay: 0.2s;
  }

  @keyframes sk-cubeGridScaleDelay {
    0%,
    70%,
    100% {
      transform: scale3D(1, 1, 1);
    }
    35% {
      transform: scale3D(0, 0, 1);
    }
  }
`;

export const ModuleLoaderContainer = styled.div`
  width: 100%;
  text-align: center;
  background-color: ${({ theme }) => theme.COLORS.secondary};
`;
